// extracted by css-extract-rspack-plugin
export default {"closeIcon":"ClauseStep-module__closeIcon___vwM7B"};